/* Контент SEO-посадочных страниц. Слаги и тексты собраны под кластеры
   поисковых запросов, по которым в рекламе были конверсии. */

const BASE = 'https://amorika.love';

export const SEO_PAGES = [
  {
    slug: 'sozdat-priglashenie-na-svadbu',
    title: 'Создать приглашение на свадьбу онлайн — бесплатно за 5 минут | Amorika',
    description: 'Создайте приглашение на свадьбу онлайн бесплатно: выберите шаблон, добавьте фото, дату и место, и отправьте гостям ссылку. Без дизайнера и типографии — готово за 5 минут.',
    h1: 'Создать приглашение на свадьбу онлайн',
    subtitle: 'Соберите красивое приглашение сами: выберите шаблон, добавьте свои фото и текст — и отправьте гостям ссылку. Бесплатно, без дизайнера и типографии.',
    intro: [
      'Чтобы создать приглашение на свадьбу онлайн, больше не нужны дизайнер, типография и недели ожидания. В конструкторе Amorika вы соберёте персональный сайт-приглашение за 5 минут: достаточно выбрать один из 16+ шаблонов, добавить ваши фотографии, имена, дату и место торжества.',
      'Сервис сам подскажет, что заполнить на каждом шаге. Можно настроить обратный отсчёт до свадьбы, карту проезда, программу дня, дресс-код и онлайн-подтверждение присутствия гостей (RSVP). Готовое приглашение вы отправляете гостям одной ссылкой — в Telegram, MAX, WhatsApp, по СМС или email.',
      'Создание и предпросмотр — бесплатно. Оплата нужна только когда вы готовы опубликовать сайт и снять отметку «черновик». После публикации приглашение хранится целый год, а менять его можно сколько угодно.',
    ],
    steps: [
      { t: 'Выберите шаблон', d: 'Более 16 дизайнов под разный стиль свадьбы — от классики до минимализма.' },
      { t: 'Добавьте свои данные', d: 'Фото пары, имена, дату, место, программу дня и список подарков.' },
      { t: 'Отправьте гостям', d: 'Опубликуйте и поделитесь ссылкой в мессенджерах или по email.' },
    ],
    faq: [
      { q: 'Можно ли создать приглашение на свадьбу бесплатно?', a: 'Да. Создание, выбор шаблона и предпросмотр бесплатны. Оплата требуется только для публикации готового сайта без водяного знака.' },
      { q: 'Сколько времени занимает создание?', a: 'В среднем 5 минут — конструктор ведёт вас по шагам и подставляет подсказки.' },
      { q: 'Нужны ли навыки дизайна?', a: 'Нет. Дизайн уже готов в шаблоне, вы лишь добавляете свои фото и текст.' },
      { q: 'Как гости получат приглашение?', a: 'Вы отправляете им ссылку в Telegram, MAX, WhatsApp, по СМС или email — открывается на любом телефоне.' },
    ],
  },
  {
    slug: 'elektronnye-priglasheniya-na-svadbu',
    title: 'Электронные приглашения на свадьбу — создать онлайн | Amorika',
    description: 'Электронные приглашения на свадьбу: сделайте цифровое приглашение-сайт с фото, картой и подтверждением присутствия. Отправка гостям в один клик, 16+ шаблонов.',
    h1: 'Электронные приглашения на свадьбу',
    subtitle: 'Современная замена бумажным открыткам: цифровое приглашение-сайт с вашими фото, картой проезда и онлайн-ответами гостей.',
    intro: [
      'Электронные приглашения на свадьбу — это удобная и экологичная замена бумажным пригласительным. Вместо печати и доставки открыток вы создаёте цифровое приглашение в виде красивого сайта и отправляете гостям ссылку в мессенджере.',
      'В Amorika электронное приглашение — это не просто картинка, а полноценная страница: фотографии пары, дата и обратный отсчёт, карта проезда к месту торжества, программа дня, дресс-код, виш-лист и форма онлайн-подтверждения присутствия. Гость открывает ссылку на телефоне и в один тап отвечает, придёт ли он.',
      'Вы видите ответы гостей в личном кабинете в реальном времени — удобно планировать рассадку и количество порций. Цифровое приглашение легко обновить в любой момент, даже после рассылки.',
    ],
    steps: [
      { t: 'Соберите цифровое приглашение', d: 'Выберите шаблон и наполните его своими фото и деталями свадьбы.' },
      { t: 'Добавьте подтверждение гостей', d: 'Включите блок RSVP — гости ответят онлайн, придут ли они.' },
      { t: 'Разошлите ссылку', d: 'Отправьте приглашение в мессенджерах — открывается на любом устройстве.' },
    ],
    faq: [
      { q: 'Чем электронное приглашение лучше бумажного?', a: 'Его не нужно печатать и развозить, можно обновить в любой момент, а гости подтверждают присутствие онлайн — вы сразу видите список.' },
      { q: 'Можно ли собрать ответы гостей?', a: 'Да, блок онлайн-подтверждения (RSVP) собирает ответы в ваш личный кабинет.' },
      { q: 'На каких устройствах открывается приглашение?', a: 'На любых — телефон, планшет, компьютер. Ничего устанавливать не нужно, открывается по ссылке в браузере.' },
      { q: 'Сколько хранится приглашение?', a: 'Опубликованный сайт-приглашение доступен в течение года.' },
    ],
  },
  {
    slug: 'svadebnye-priglasheniya-onlayn',
    title: 'Свадебные приглашения онлайн — красивые шаблоны | Amorika',
    description: 'Свадебные приглашения онлайн: 16+ красивых шаблонов, ваши фото, карта и RSVP. Сделайте онлайн-пригласительное и отправьте гостям ссылку. Готово за 5 минут.',
    h1: 'Свадебные приглашения онлайн',
    subtitle: 'Готовые красивые шаблоны под любой стиль свадьбы. Добавьте свои фото и текст — и поделитесь ссылкой с гостями.',
    intro: [
      'Свадебные приглашения онлайн — быстрый способ красиво пригласить гостей без типографии. Вы выбираете готовый дизайн, добавляете свои фотографии и детали торжества, а сервис превращает их в элегантный сайт-приглашение.',
      'В каталоге Amorika более 16 шаблонов: классические, акварельные, минималистичные, тёмные и яркие — есть варианты под любую атмосферу свадьбы. Каждый шаблон адаптирован под телефон, ведь большинство гостей откроет приглашение именно со смартфона.',
      'Кроме оформления, онлайн-приглашение умеет больше бумажного: обратный отсчёт, карта проезда, программа дня, список подарков и онлайн-подтверждение присутствия. Поделиться можно одной ссылкой — в Telegram, MAX, WhatsApp, по СМС или email.',
    ],
    steps: [
      { t: 'Выберите дизайн', d: '16+ шаблонов под разный стиль — от классики до современного минимализма.' },
      { t: 'Персонализируйте', d: 'Добавьте фото, имена, дату, место и нужные блоки.' },
      { t: 'Поделитесь ссылкой', d: 'Отправьте онлайн-приглашение гостям в мессенджерах.' },
    ],
    faq: [
      { q: 'Сколько шаблонов доступно?', a: 'Более 16 готовых дизайнов под разный стиль свадьбы, и список пополняется.' },
      { q: 'Можно ли поменять шаблон после создания?', a: 'Да, дизайн и любой контент можно менять в любой момент.' },
      { q: 'Приглашение хорошо выглядит на телефоне?', a: 'Да, все шаблоны адаптивные и оптимизированы под смартфоны.' },
      { q: 'Нужно ли что-то устанавливать гостям?', a: 'Нет, приглашение открывается по ссылке в обычном браузере.' },
    ],
  },
  {
    slug: 'konstruktor-svadebnyh-priglasheniy',
    title: 'Конструктор свадебных приглашений — собрать сайт-приглашение | Amorika',
    description: 'Конструктор свадебных приглашений Amorika: соберите сайт-приглашение по шагам — фото, дата, карта, программа, RSVP и виш-лист. Без навыков дизайна, готово за 5 минут.',
    h1: 'Конструктор свадебных приглашений',
    subtitle: 'Собирайте приглашение по шагам, как из блоков: фото, дата, карта, программа, подарки и подтверждение гостей. Подсказки на каждом этапе.',
    intro: [
      'Конструктор свадебных приглашений Amorika помогает собрать приглашение самостоятельно, без дизайнера и сложных программ. Вы наполняете готовый шаблон блоками: обложка с фото, дата и обратный отсчёт, карта проезда, программа дня, дресс-код, виш-лист и форма подтверждения присутствия.',
      'Каждый блок можно включить или выключить, поменять местами и отредактировать прямо в браузере — рядом сразу видно живой предпросмотр на экране телефона. Конструктор ведёт по шагам и подсказывает, что заполнить, поэтому справится даже тот, кто никогда не делал сайтов.',
      'Когда приглашение готово, вы публикуете его и получаете личную ссылку вида amorika.love/site/ваше-имя. Её удобно отправить гостям в мессенджерах, а все ответы по присутствию собираются в вашем личном кабинете.',
    ],
    steps: [
      { t: 'Добавляйте блоки', d: 'Фото, дату, карту, программу, дресс-код, подарки и RSVP — что нужно именно вам.' },
      { t: 'Редактируйте вживую', d: 'Меняйте тексты и фото с предпросмотром на экране телефона.' },
      { t: 'Публикуйте и делитесь', d: 'Получите личную ссылку и отправьте её гостям.' },
    ],
    faq: [
      { q: 'Нужны ли навыки, чтобы пользоваться конструктором?', a: 'Нет. Конструктор ведёт по шагам с подсказками — нужно лишь добавить свои данные.' },
      { q: 'Можно ли убрать ненужные блоки?', a: 'Да, любой блок включается и выключается, а порядок можно менять.' },
      { q: 'Видно ли результат во время сборки?', a: 'Да, рядом всегда живой предпросмотр на экране телефона.' },
      { q: 'Какой адрес будет у приглашения?', a: 'Личная ссылка вида amorika.love/site/ваше-имя, её можно настроить.' },
    ],
  },
];

/* JSON-LD для страницы: WebPage + FAQPage + хлебные крошки. */
export function pageJsonLd(page) {
  const url = `${BASE}/${page.slug}/`;
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': url,
        url,
        name: page.h1,
        description: page.description,
        inLanguage: 'ru-RU',
        isPartOf: { '@type': 'WebSite', name: 'Amorika', url: BASE },
      },
      {
        '@type': 'FAQPage',
        mainEntity: page.faq.map(f => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Главная', item: BASE + '/' },
          { '@type': 'ListItem', position: 2, name: page.h1, item: url },
        ],
      },
    ],
  };
}
